<mat-dialog-content class="modal-content">
  <div class="modal-header">
    <div class="news-of-the-week-container">
      <h1>News of the week</h1>
      <p>
        {{ data.news }}
      </p>
    </div>

    <div class="credibility-wrapper compact">
      <h2 class="credibility-title">Your credibility</h2>
      <div class="credibility-pill">
        <span class="credibility-value"> {{ data.credibility }} </span>
        <span class="credibility-arrow">
          <ng-container *ngIf="data.credibility_delta < 0">
            <span class="credibility-decreases">↓</span>
          </ng-container>
          <ng-container *ngIf="data.credibility_delta === 0">
            <span class="credibility-neutral">-</span>
          </ng-container>
          <ng-container *ngIf="data.credibility_delta > 0">
            <span class="credibility-increases">↑</span>
          </ng-container>
        </span>
      </div>
      <div class="credibility-increase-row">
        <span class="label">
          <ng-container *ngIf="data.credibility_delta < 0">
            <span class="delta-negative"
              >Decreases {{ data.credibility_delta }}
            </span>
          </ng-container>
          <ng-container *ngIf="data.credibility_delta === 0">
            <span class="delta-neutral">- </span>
          </ng-container>
          <ng-container *ngIf="data.credibility_delta > 0">
            <span class="delta-positive"
              >Increases +{{ data.credibility_delta }}</span
            >
          </ng-container>
        </span>
      </div>
    </div>
  </div>

  <div class="modal-body" *ngIf="data.groupedLevelChanges as changes">
    <h1>Effects on recipients</h1>
    <p *ngIf="!levelChangeKeyPairs.length" class="no-changes-msg">
      No changes on the organization.
    </p>
    <div class="level-row" *ngFor="let pair of levelChangeKeyPairs">
      <div class="level-col" *ngFor="let key of pair">
        <ng-container *ngIf="changes[key] as list">
          <h3 class="level-title">
            The following people moved on to the stage of
            <br />
            <span>
              <strong> {{ key }}: </strong>
            </span>
          </h3>
          <ng-container
            *ngIf="
              allExpanded && list.length > 2 && splits[key];
              else singleColumn
            "
          >
            <div class="two-col">
              <ul class="member-list">
                <li *ngFor="let item of splits[key].left">
                  {{ item.label }}
                </li>
              </ul>
              <ul class="member-list">
                <li *ngFor="let item of splits[key].right">
                  {{ item.label }}
                </li>
              </ul>
            </div>
          </ng-container>
          <ng-template #singleColumn>
            <ul class="member-list">
              <li
                *ngFor="let item of allExpanded ? list : (list | slice : 0 : 2)"
              >
                {{ item.label }}
              </li>
            </ul>
          </ng-template>
        </ng-container>
      </div>
    </div>
    <div class="global-toggle-wrapper" *ngIf="hasOverflow">
      <button type="button" class="toggle-btn" (click)="toggleAll()">
        {{ allExpanded ? "Show less" : "Show more" }}
      </button>
    </div>

    <h1 *ngIf="data.adoption_stage">Effects on the organization</h1>
    <p *ngIf="data.adoption_stage" class="effects-organization">
      {{
        data.is_adoption_promoted
          ? "Your company moved to the stage"
          : "Your company continues to the stage"
      }}
      <span class="effect-organization"> {{ data.adoption_stage }} </span>
    </p>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="modal-actions">
  <button class="continue-btn" (click)="onContinue()">Continue</button>
</mat-dialog-actions>
